import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: process.env.THEME
    }
  }
}

// Tell Vuetify which icon font to use. We import
// 'material-design-icons-iconfont' in main.js, so set to 'md'.
opts.icons = {
  iconfont: 'md'
}

const vuetify = new Vuetify(opts)

export default vuetify
